import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

import { useState, useEffect } from 'react';
import classNames from 'classnames/bind';
import styles from '@/styles/superstack/base/Slider.module.scss';
import { Chip } from '@/src/component/superstack/base/Chip';
import PropTypes from 'prop-types';

const SSRangeYear = ({ min, max, step, minV, maxV, updateContainer }) => {
  const cx = classNames.bind(styles);
  const [rangeYear, setRangeYear] = useState([minV || min, maxV || max]);

  const getChipText = (rangeYear) => {
    if (!rangeYear) {
      return '';
    }

    const [minV, maxV] = rangeYear;
    let chipText;
    if (minV === min && maxV === max) {
      chipText = '경력 무관';
    } else if (minV === min) {
      chipText = maxV + '년 이하';
    } else if (maxV === max) {
      chipText = minV + '년 이상';
    } else if (minV && maxV) {
      chipText = minV + '년 이상 ~ ' + maxV + '년 이하';
    }
    return chipText;
  };

  const [chipText, setChipText] = useState(() => {
    return getChipText(rangeYear);
  });

  const handleChange = (nextRange) => {
    setRangeYear(nextRange);
    setChipText(getChipText(nextRange));

    if (updateContainer) {
      updateContainer(nextRange);
    }
  };

  useEffect(() => {
    setRangeYear([minV, maxV]);
    setChipText(getChipText([minV, maxV]));
  }, [minV, maxV]);

  const markStyle = {
    // .caption-text-2
    'font-family': 'NotoSansKR',
    'font-size': '10px',
    'line-height': '14px',
    'font-weight': 400,
    color: '#757575',
    top: '6px',
  };
  const marks = {
    0: { label: '0', style: markStyle },
    5: { label: '5', style: markStyle },
    10: { label: '10', style: markStyle },
    15: { label: '15', style: markStyle },
  };

  return (
    <div>
      <Chip mode={rangeYear.join() === [min, max].join() ? 'text' : 'filled'} size="sm">
        {chipText}
      </Chip>
      <Slider
        range
        dots
        allowCross={false}
        defaultValue={[min, max]}
        min={min}
        max={max}
        step={step}
        onChange={handleChange}
        value={rangeYear}
        marks={marks}
        handleStyle={{
          width: '12px',
          height: '12px',
          background: '#FFFFFF',
          border: '1px solid #EEEEEE',
          'box-shadow': '0 2px 4px rgba(33, 33, 33, 0.08)',
          opacity: 1,
        }}
        trackStyle={{
          height: '1px',
          background: '#006DFF',
          border: '1px solid #006DFF',
          'border-radius': '2px',
        }}
        railStyle={{
          height: '1px',
          background: '#C4C4C4',
          border: '1px solid #E0E0E0',
          'box-sizing': 'border-box',
          'border-radius': '2px',
        }}
        dotStyle={{
          bottom: '-7px',
          width: '1px',
          height: '3px',
          background: '#BDBDBD',
          border: 'none',
          'border-radius': '4px',
          'border-color': '#BDBDBD',
        }}
        activeDotStyle={{}}
        className={cx('ss-slider')}
      />
    </div>
  );
};

const MSSRangeYear = ({ min, max, step, minV, maxV, updateContainer }) => {
  const cx = classNames.bind(styles);
  const [rangeYear, setRangeYear] = useState([minV || min, maxV || max]);

  const getChipText = (rangeYear) => {
    if (!rangeYear) {
      return '';
    }

    const [minV, maxV] = rangeYear;
    let chipText;
    if (minV === min && maxV === max) {
      chipText = '경력 무관';
    } else if (minV === min) {
      chipText = maxV + '년 이하';
    } else if (maxV === max) {
      chipText = minV + '년 이상';
    } else if (minV && maxV) {
      chipText = minV + '년 이상 ~ ' + maxV + '년 이하';
    }
    return chipText;
  };

  const [chipText, setChipText] = useState(() => {
    return getChipText(rangeYear);
  });

  const handleChange = (nextRange) => {
    setRangeYear(nextRange);
    setChipText(getChipText(nextRange));

    if (updateContainer) {
      updateContainer(nextRange);
    }
  };

  useEffect(() => {
    setRangeYear([minV, maxV]);
    setChipText(getChipText([minV, maxV]));
  }, [minV, maxV]);

  const markStyle = {
    // .body-text-3
    'font-family': 'NotoSansKR',
    'font-size': '13px',
    'line-height': '20px',
    'font-weight': 400,
    color: '#757575',
    top: '6px',
  };

  const marks = {
    0: { label: '0', style: markStyle },
    5: { label: '5', style: markStyle },
    10: { label: '10', style: markStyle },
    15: { label: '15', style: markStyle },
  };

  return (
    <div>
      <Chip
        mode={rangeYear.join() === [min, max].join() ? 'text' : 'filled'}
        style={{
          fontSize: '14px',
          lineHeihgt: '20px',
          padding: '5px 12px 7px 12px',
        }}
      >
        {chipText}
      </Chip>
      <div style={{ padding: '10px 8px 0px 8px' }}>
        <Slider
          range
          dots
          allowCross={false}
          defaultValue={[min, max]}
          min={min}
          max={max}
          step={step}
          onChange={handleChange}
          value={rangeYear}
          marks={marks}
          handleStyle={{
            width: '16px',
            height: '16px',
            background: '#FFFFFF',
            border: '1px solid #EEEEEE',
            'box-shadow': '0 2px 4px rgba(33, 33, 33, 0.08)',
            opacity: 1,
          }}
          trackStyle={{
            height: '4px',
            background: '#006DFF',
            border: '1px solid #006DFF',
            'border-radius': '2px',
          }}
          railStyle={{
            height: '4px',
            background: '#C4C4C4',
            border: '1px solid #E0E0E0',
            'box-sizing': 'border-box',
            'border-radius': '2px',
          }}
          dotStyle={{
            bottom: '-7px',
            width: '1px',
            height: '3px',
            background: '#BDBDBD',
            border: 'none',
            'border-radius': '4px',
            'border-color': '#BDBDBD',
          }}
          activeDotStyle={{}}
          className={cx('ss-slider')}
        />
      </div>
    </div>
  );
};

const SSRangeMinYear = ({ min, max, step, minV, updateContainer }) => {
  const cx = classNames.bind(styles);
  const [val, setval] = useState(minV || min);

  const getChipText = (val) => {
    return val === min ? '경력 무관' : val + '년 이상';
  };

  const [chipText, setChipText] = useState(() => {
    return getChipText(val);
  });

  const handleChange = (nextVal) => {
    setval(nextVal);
    setChipText(getChipText(nextVal));

    if (updateContainer) {
      updateContainer(nextVal);
    }
  };

  const markStyle = {
    // .caption-text-2
    'font-family': 'NotoSansKR',
    'font-size': '10px',
    'line-height': '14px',
    'font-weight': 400,
    color: '#757575',
    top: '6px',
  };
  const marks = {
    0: { label: '0', style: markStyle },
    5: { label: '5', style: markStyle },
    10: { label: '10', style: markStyle },
    15: { label: '15', style: markStyle },
  };

  useEffect(() => {
    setval(minV);
    setChipText(getChipText(minV));
  }, [minV]);

  return (
    <div>
      <Chip mode={val === min ? 'text' : 'filled'} size="sm">
        {chipText}
      </Chip>
      <Slider
        // reverse={true}
        startPoint={max}
        dots
        allowCross={false}
        defaultValue={min}
        min={min}
        max={max}
        step={step}
        onChange={handleChange}
        value={val}
        marks={marks}
        handleStyle={{
          width: '12px',
          height: '12px',
          background: '#FFFFFF',
          border: '1px solid #EEEEEE',
          'box-shadow': '0 2px 4px rgba(33, 33, 33, 0.08)',
          opacity: 1,
        }}
        trackStyle={{
          height: '1px',
          background: '#006DFF',
          border: '1px solid #006DFF',
          'border-radius': '2px',
        }}
        railStyle={{
          height: '1px',
          background: '#C4C4C4',
          border: '1px solid #E0E0E0',
          'box-sizing': 'border-box',
          'border-radius': '2px',
        }}
        dotStyle={{
          bottom: '-7px',
          width: '1px',
          height: '3px',
          background: '#BDBDBD',
          border: 'none',
          'border-radius': '4px',
          'border-color': '#BDBDBD',
        }}
        activeDotStyle={{}}
        className={cx('ss-slider')}
      />
    </div>
  );
};

SSRangeYear.prototype = {
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
};
SSRangeYear.defaultProps = {
  min: 0,
  max: 15,
  step: 1,
};

SSRangeMinYear.prototype = {
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
};
SSRangeMinYear.defaultProps = {
  min: 0,
  max: 15,
  step: 1,
};

export { SSRangeYear, SSRangeMinYear, MSSRangeYear };
